module.exports = __webpack_public_path__ + "static/media/cheese.f77ae7b1.svg";